export default __webpack_public_path__ + "static/media/illegal-moves.04d88ff6.md";